export default __webpack_public_path__ + "static/media/DSC05995.aee74759.jpg";